import React, { useState } from 'react'
import { primaryColor } from '../../assets/jss/material-dashboard-react';
import { useMobileLandscape, useMobileContext } from '../../Context/ContextProvider'
import { ReactComponent as MobileIcon } from '../../assets/mobile.svg'
import { ReactComponent as RemoteIcon } from '../../assets/remote.svg'
import { ReactComponent as RemoteIconWhite } from '../../assets/remoteWhite.svg'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import Modal from 'react-bootstrap/Modal'
import { Button } from '@mui/material';
import { injectIntl, FormattedMessage, IntlShape, useIntl } from 'react-intl';
import moment from 'moment'


interface SigCheck {
    signalCheck: boolean
    timestamp: Date
}

interface Props {
    deviceConfig: boolean
    invertColors: boolean
    signalCheckData: SigCheck
}

const LCLDeviceSetupOverview: React.FC<Props> = ({ deviceConfig, invertColors, signalCheckData }) => {
    const intl: IntlShape = useIntl()
    const isLandscape = useMobileLandscape()
    const isMobile = useMobileContext()
    const [showModal, setShowModal] = useState<boolean>(false)
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const handleStep3Click = (): void => {
        if (!signalCheckData.signalCheck) {
            setShowModal(true)
        } else {
            setShowPopup(true)
        }
    }

    const showDate = (): void => {
        
        if (signalCheckData.signalCheck) {
            setShowPopup(true)
        }
    }

    const handleClose = (e):void => {
        e.stopPropagation()
        setShowPopup(false)
    }

    

    return (
        <div>
            <Modal
                show={showModal}
                style={{
                    transform: isMobile ? 'translate(0, 30%)' : 'translate(35vw, 30%)',
                    width: isMobile ? '100vw' : '30vw'
                }}
            >
                <Modal.Body>
                    <p style={{ fontSize: 18 }}><b><FormattedMessage id='You need to run a signal test from the device to ensure you are using the best option available. This can only be done from the device itself using the ' />{window.location.hostname.includes('zonelog.net') ? 'ZONELOG' : 'CharIoT'} <FormattedMessage id='App'/></b></p>
                </Modal.Body>
                <Modal.Footer>
                    {isMobile ?
                        <FullWidthMobileButton text={intl.formatMessage({ id: 'Close' })} onClick={(): void => setShowModal(false)} color="error" disabled={false} /> :
                        <Button onClick={(): void => setShowModal(false)} color="error" variant='contained'><FormattedMessage id='Close' /></Button>}
                </Modal.Footer>
            </Modal>
            <h5 style={{textAlign: "center"} }><b><FormattedMessage id='Device Installation' /></b></h5>
            <div style={{
            
                background: invertColors ? 'inherit' : primaryColor[0],
                width: isLandscape ? "100%" : "110%",
                transform: isLandscape ? "translateX(0)" : "translateX(-5%)",
                height: invertColors ? 150 : 176,
                borderRadius: 5,
                boxShadow: invertColors ? 'none' : "2px 2px 10px gray",
                display: "flex",
                justifyContent: "center",
                alignItems: invertColors ? "top": "center"
            }}>
                <div style={{ display: "flex", width: "90%", justifyContent: "space-between", position: "relative" }}>
                    <div>
                        <h4 style={{ color: invertColors ? 'inherit' : "white", textAlign: "center" }}><b><FormattedMessage id='Step 1' /></b></h4>
                        <div style={{display: "flex", justifyContent: "center", alignItems: "center"} }>
                            <div style={{ borderRadius: 1000, width: 50, height: 50, background: '#00bf00', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                <MobileIcon style={{ transform: 'scale(1.2)' }} />
                            </div>
                        </div>
                        <p style={{ color: invertColors ? 'inherit' : "white", textAlign: "center", margin: "10px 0 0 0" }}><FormattedMessage id='Config from' /> <br /> <FormattedMessage id='App' /></p>
                    </div>
                    <div style={{ position: "absolute", width: "44%", height: 10, background: '#00bf00', top: invertColors ? 54 : 59, left: "6%", zIndex: -1} }></div>
                    <div>
                        <h4 style={{ color: invertColors ? 'inherit' : "white", textAlign: "center" }}><b><FormattedMessage id='Step 2'/></b></h4>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div style={{ borderRadius: 1000, width: 50, height: 50, background: deviceConfig ?  '#00bf00' : invertColors ? 'red' : 'white', display: "flex", justifyContent: "center", alignItems: 'center' }}>
                                {deviceConfig || invertColors ? <RemoteIconWhite style={{ transform: 'scale(1.8)' }} /> :
                                    <RemoteIcon style={{ transform: 'scale(1.8)'  }} />}
                            </div>
                        </div>
                        <p style={{ color: invertColors ? 'inherit' : "white", textAlign: "center", margin: "10px 0 0 0" }}><FormattedMessage id='Config from' /> <br /> <FormattedMessage id='Device'/></p>
                    </div>
                    <div style={{ position: "absolute", width: "44%", height: 10, background: deviceConfig ? signalCheckData.signalCheck ? '#00bf00' : '#FF6700' : 'white', top: invertColors ? 54 : 59, left: "49%", zIndex: -1 }}></div>
        
                    <div>
                        <h4 style={{ color: invertColors ? 'inherit' : "white", textAlign: "center" }}><b><FormattedMessage id='Step 3' /></b></h4>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <div
                                style={{
                                    borderRadius: 1000,
                                    width: 50,
                                    height: 50,
                                    background:
                                        deviceConfig ?
                                            signalCheckData.signalCheck ? '#00bf00' : '#FF6700'
                                            : invertColors ? 'red' : 'white',
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: 'center',
                                    cursor: !signalCheckData.signalCheck ? 'inherit' : 'pointer',
                                    position: 'relative'
                                }}
                                onClick={(): void => handleStep3Click()}
                                onMouseEnter={(): void => showDate()}
                                onMouseLeave={():void => setShowPopup(false)}
                            >
                                {deviceConfig ? signalCheckData.signalCheck ? <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                                    <path d="M10 30L20 40L40 14" stroke="white" strokeWidth="4" strokeLinecap="round" />
                                </svg> :
                                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                                        <path d="M25 10L25 30M25 40L25 41" stroke="white" strokeWidth="6" strokeLinecap="round" />
                                    </svg>

                                : <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                                        <path d="M38 12L12 38M12 12L38 38" stroke={invertColors ? "white": "currentColor"} strokeWidth="4" strokeLinecap="round" />
                                </svg>  
                                }
                                {showPopup &&
                                    <div
                                        style={{
                                            position: 'absolute',
                                            background: '#f4f4f4',
                                            left: '-220px',
                                            padding: 10,
                                            boxShadow: '2px 2px 10px #00000060',
                                            borderRadius: "5px",
                                            borderLeft: "10px solid #00ADBA"
                                        }}
                                    >
                                        
                                        <h5>Signal Check performed</h5>
                                        <p style={{ textAlign: 'center' }}>{moment(signalCheckData?.timestamp).format('DD MMM YYYY HH:mm')}</p>
                                        {isMobile && <div style={{width: '100%'} }>
                                            <FullWidthMobileButton text='close' onClick={(e): void => handleClose(e) } color='error' disabled={false} />
                                        </div>}
                                    </div>
                                }
                            </div>
                        </div>
                        {signalCheckData.signalCheck ? <p style={{ color: invertColors ? 'inherit' : "white", textAlign: "center", margin: "10px 0 0 0" }}><FormattedMessage id='Installation' /><br /> <FormattedMessage id='Complete'/></p> :
                            <p style={{ color: invertColors ? 'inherit' : "white", textAlign: "center", margin: "10px 0 0 0" }}><FormattedMessage id='No Signal' />  <br /><FormattedMessage id='Check'/></p>}
                    </div>
                
                </div>
            </div>
        </div>
    )
}
export default LCLDeviceSetupOverview